import React from 'react';
import { APP_CONFIG, THEME } from '../../constants/appConfig';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Log error to console in development
        if (process.env.NODE_ENV === 'development') {
            console.error('Error caught by ErrorBoundary:', error, errorInfo);
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '20px',
                    margin: '20px',
                    backgroundColor: '#FFF5F5',
                    border: `2px solid ${THEME.colors.danger}`,
                    borderRadius: '8px',
                    color: THEME.colors.danger,
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
                    <h2 style={{ margin: '0 0 16px 0', color: THEME.colors.danger }}>
                        Something went wrong
                    </h2>
                    <p style={{ marginBottom: '16px', color: '#666' }}>
                        We encountered an unexpected error while loading this component.
                    </p>
                    
                    {process.env.NODE_ENV === 'development' && this.state.error && (
                        <details style={{
                            marginTop: '20px',
                            padding: '10px',
                            backgroundColor: '#F8F8F8',
                            border: '1px solid #DDD',
                            borderRadius: '4px',
                            textAlign: 'left'
                        }}>
                            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                                Error Details (Development Mode)
                            </summary>
                            <pre style={{ 
                                fontSize: '12px', 
                                overflow: 'auto',
                                marginTop: '10px',
                                color: '#333'
                            }}>
                                {this.state.error.toString()}
                                {this.state.errorInfo.componentStack}
                            </pre>
                        </details>
                    )}
                    
                    <div style={{ marginTop: '20px' }}>
                        <button
                            onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: THEME.colors.primary,
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                marginRight: '10px'
                            }}
                        >
                            Try Again
                        </button>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#666',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Reload Page
                        </button>
                    </div>
                    
                    <div style={{ 
                        marginTop: '20px', 
                        fontSize: '12px', 
                        color: '#666',
                        borderTop: '1px solid #DDD',
                        paddingTop: '10px'
                    }}>
                        {APP_CONFIG.name} v{APP_CONFIG.version} • Error ID: {Date.now()}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;